export class ContestEntry {
  constructor(
    public contest_id: string,
    public contest_slug: string,
    public firstName: string,
    public lastName: string,
    public email: string,
    public address: string,
    public codeArea: string,
    public city: string,
    public phoneNumber: string,
    public userType: string,
    public questions: string[],
    public answers: string[],
    public schoolName: string,
    public classroom: string,
    public submitted: boolean = false
  ) {}
}
